"use client";

import { ReactNode } from "react";
import { DialogsProvider } from "@/lib/context/dialogs.context";
import { MarcusChallengeDialog } from "@/components/marcus-challenge-dialog";

export function DialogsProviderWithDialogs({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <DialogsProvider>
      {children}
      <MarcusChallengeDialog />
    </DialogsProvider>
  );
}
